import { render, staticRenderFns } from "./VueNoVNC.vue?vue&type=template&id=ff9c064a&"
import script from "./VueNoVNC.vue?vue&type=script&crossorigin=anonymous&lang=js&"
export * from "./VueNoVNC.vue?vue&type=script&crossorigin=anonymous&lang=js&"
import style0 from "./VueNoVNC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports